"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatorySchema = exports.SignatorySigningSchema = exports.SignatoryBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
exports.SignatoryBaseSchema = zod_1.z.object({
    firstName: zod_1.z.string().optional(),
    middleName: zod_1.z.string().optional(),
    lastName: zod_1.z.string().optional(),
    position: zod_1.z.string().optional(),
    yachtName: zod_1.z.string().optional(),
    cocNumber: zod_1.z.string().optional(),
    cocIssuingAuthority: zod_1.z.string().optional(),
    cocStatus: zod_1.z.enum(['Not Registered', 'Valid']).default('Not Registered').optional(),
    email: zod_1.z.string().email({ message: 'The email is not valid' }).or(zod_1.z.literal('')).optional().nullish(),
});
// Stored / draft signatory records may omit position. The Signatory step (signing and
// admin signatory edit) must collect a position before the request can proceed.
exports.SignatorySigningSchema = exports.SignatoryBaseSchema.extend({
    position: zod_1.z.string().trim().min(1, { message: 'Position is required' }),
});
exports.SignatorySchema = exports.SignatoryBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
//# sourceMappingURL=Signatory.js.map